import container from './CQRS';

async function fetchTodayTasks(childId) {
  const todayTasks = await container.queriesController.fetchTodayTasksRequest(childId);
  return todayTasks;
}

async function updateStatusToTask(taskId) {
  try {
    const data = await container.commandsController.updateTaskAsComplete(taskId);
    return data;
  } catch (error) {
    throw new Error('Oops!, Error when try to update the status to the task');
  }
}

export { fetchTodayTasks, updateStatusToTask };
